<template>
  <div class="flex items-start gap-3 rounded-xl border p-3 text-sm" :class="tones[tone]" :role="tone === 'error' ? 'alert' : 'status'">
    <AppIcon :name="tone === 'success' ? 'check' : tone === 'info' ? 'info' : 'alert'" :size="16" class="mt-0.5 shrink-0" />
    <div class="min-w-0 flex-1"><slot /></div>
  </div>
</template>

<script>
import AppIcon from './AppIcon.vue'

export default {
  name: 'AlertBanner',
  components: { AppIcon },
  props: { tone: { type: String, default: 'error' } },
  setup() {
    return {
      tones: {
        error: 'border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-900 dark:bg-rose-950/40 dark:text-rose-300',
        warning: 'border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-900 dark:bg-amber-950/40 dark:text-amber-300',
        success: 'border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-900 dark:bg-emerald-950/40 dark:text-emerald-300',
        info: 'border-cyan-200 bg-cyan-50 text-cyan-800 dark:border-cyan-900 dark:bg-cyan-950/40 dark:text-cyan-300'
      }
    }
  }
}
</script>
